import "./sidebar.css";
// import logo from '../../image
import { Link, useNavigate } from "react-router-dom";
import { TreeView, TreeItem } from "@mui/material";
import { FaDashcube, FaUser, FaUsers } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";
import { AiFillProfile } from "react-icons/ai";
import { logout } from "../actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from "react-toastify";
// import ExpandMoreIcon from '@mui/material'
// import AddIcon from '@mui/mate
// import ImportExportIcon from '@mui/material'

const Sidebar = ({underLine}) => {
  const { error, user, isAuthenticated } = useSelector((state) => state.users);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
    // if (!isAuthenticated) {
    //   navigate("/");
    // }
  }, [ error]);

  const logOutHandler = () => {
    dispatch(logout());
    navigate("/");
  };

  const clearNavbar = () => {

    if(window.innerWidth <= 600){
       
    document.getElementsByClassName("menuContainer")[0].classList.add("hide");
    document
      .getElementsByClassName("menuContainer")[0]
      .classList.remove("show");
    }
  };
  return (
    <div className="sideBarContainer">
      <div className="sidebar">
        <Link to="/dashboard">
          <img
            src={
              require('../images/SEC.png')
            }
            alt="Logo"
          />
          {/* <h1>Logo</h1> */}
        </Link>
        <Link to="/dashboard" className={underLine === 'dashboard' ? "active" : ""}  onClick={(e) => {
            clearNavbar();
          }} >
          <p>
            <FaDashcube  />
            Dashboard
          </p>
        </Link>
        {
          user?.role === 'admin' && (

         <h4>User</h4>
          )}
        {
          user?.role === 'admin' && (
   
        <Link
          to="/user"
          onClick={(e) => {
            clearNavbar();
          }}
          className={underLine === 'users-management' ? "active" : ""}
        >
          <p>
            <AiFillProfile  />
            Users Management
          </p>
        </Link>
          )
        }

{
  user?.role === 'admin' ||  user?.role === 'superviser' ? (
           <>
            <h4>FILE</h4>
        <Link
          to="/file/management"
          onClick={(e) => {
            clearNavbar();
          }}
          className={underLine === 'file-management' ? "active" : ""}
          
        >
          <p>
            <AiFillProfile />
            File Management
          </p>
        </Link>
           </>

          ): ""}
        

{
          user?.role === 'admin' ||  user?.role === 'lead-counsellor' ? (
       <>
         <h4>Application</h4>

<Link
  to="/student/application"
  onClick={(e) => {
    clearNavbar();
  }}
  className={underLine === 'app-management' ? "active" : ""}

>
  <p>
    <FaUsers />
    Applications Management
  </p>
</Link>
       </>
          ) : ""}


{
          user?.role === 'admin' ||  user?.role === 'lead-counsellor' ||  user?.role === 'counsellor' ? (
        <Link
          to="/asigned/applications"
          onClick={(e) => {
            clearNavbar();
          }}
          className={underLine === 'ass-management' ? "active" : ""}

        >
          <p>
            <FaUsers />
            Assigned Application
          </p>
        </Link>
          ) : ""}

      </div>
    </div>
  );
};

export default Sidebar;
